export type ErrorType = {
    [key: string]: {
        isErrored: boolean,
        errorMsg: string
    }
}

export type GlobalErrorStateType = {
    isError: boolean
    message: string
}

export type FCMConfig = {
    token: string
    creationTimeStamp: number
}

export type Pagination = {
    currentPage: number
    lastPage: number
    from: number
    to: number
    totalItems: number
    itemsPerPage: number
}

export type AppInfoStateType = {
    bundleId: string
    osVersion: string
    platform: string
    appVersion: string
    appBuildNo: string
    brand: string
    manufacturer: string
    deviceName: string
}

export type WebInfoStateType = {
    uniqueDeviceId: string
}

export type AppTimerStateType = {
    lastBackgroundInitTime: number
    eyengageLastUpdateTime: number
}

export type MiscStateType = {
    hardRefreshApp: boolean
    refreshLastObservation: boolean
    isFileDownloading: boolean
    themeColors: {
        ['dark']: BrandColorType
        ['light']: BrandColorType
    }
    showDownloadAppBanner: boolean
}

export type BrandColorType = {
    backgroundColor: string
    foregroundColor: string
    borderColor: string
    showBrandBorder: boolean
}

export enum EnvType {
    API_BASE_URL = 'API_BASE_URL',
    NX_APP_ENV = 'NX_APP_ENV'
}

export type LogData = {
    label: string
    value: string
}

export type MediaAttachment = {
    isProcessing: boolean
    media: MediaType
    thumb: MediaType
    id?: string
    // type: string
    // url: string
    // thumbUrl: string
}

export type MediaType = {
    url: string
    contentType: string
    fileName?: string
}

export type LikesData = {
    count: number
    data: any[]
    likedByMe: boolean
}

export type CommentsData = {
    count: number
    data: any[]
}

export type ReactionCommentData = {
    id: string
    text: string
    user: {
        name: string
        photo: string
    }
    date: string
    self: boolean
}

export type DropdownType = {
    id: number
    value: string
}

export type PersonDetailType = {
    name: string,
    signature: SignatureType
}

export type SignatureType = {
    url: string,
    fileName: string
};

export type FilePickerType = {
    fileName: string
    fileSize: string
    fileExtension: string
    type: string
    uri: string
}

export type WhatsNewDataType = {
    version: string;
    release_date: string;
    features: string[];
    notes: string;
};

export type ForcedUpdateType = {
    appVersion: string
    isForceUpdateRequired: boolean
}

export type ApiRateLimitType = {
    isRateLimitActive: boolean
    retryAfter: number
}